import type { Environment } from '#app/shared/contexts/AppContext'
import { restClient } from './restClient'

/**
 * Get environment data from the server.
 */
export const getEnvironmentData = () => {
  return restClient.get<Environment>('/api/environment?appid=portal-broker')
}
